import { createSurveyStyles } from '@sm/webassets';
import { SurveyThemeType } from '@sm/webassets/dist/components/SurveyTheme';

export type ExitLinkClassNames = 'exitLink';
export type ExitLinkStylesProps = { userAgent?: string };

const useSurveyStyles = createSurveyStyles<ExitLinkClassNames>((theme: SurveyThemeType) => {
  return {
    exitLink: {
      /**
       * Current font in `production`, naturally looks bigger than "National 2"
       * @todo Reconsider `font-family`, `font-size` and `font-weight`.
       */
      fontFamily: 'Arial, sans-serif',
      fontSize: theme.exitLink?.fontSize,
      fontWeight: theme.exitLink?.fontWeight,
      lineHeight: 1.5,
      letterSpacing: 1,
      color: theme.titleColor,
      backgroundColor: theme.exitLink?.backgroundColor,
      transition: 'all 0.2s linear',
      '&:focus, &:hover': {
        outlineOffset: 4,
        // Safari seems to have an outline bug, may not render without boxshadow
        boxShadow: '0 0 3px transparent',
      },
    },
  };
});

export default useSurveyStyles;
